import type { TFunction } from 'i18next';
import type { TestContext, ValidationError } from 'yup';

export const NO_FILE_ERRORS_TEST_NAME = 'no-errors-in-files';

interface FileArrayItem {
  readonly template?: readonly { readonly error?: boolean; readonly messageError?: string }[];
}

/**
 * Shared yup test for any file-upload array field (build.applicationFiles, configure.parameterTemplates, ...).
 * Re-surfaces the errored file's own message (file too large, format not accepted, ...) at the field level so
 * that re-validating on a "Next"/"Create" click (form.trigger) keeps the specific banner message instead of
 * overwriting it with a generic one.
 */
export function noFileErrorsTest(t: TFunction) {
  return {
    name: NO_FILE_ERRORS_TEST_NAME,
    test: (files: readonly FileArrayItem[] | undefined, context: TestContext): boolean | ValidationError => {
      const erroredFile = files
        ?.flatMap((file) => file.template ?? [])
        .find((templateFile) => templateFile.error === true);

      return erroredFile
        ? context.createError({ message: erroredFile.messageError || t('genericError.invalidFormat') })
        : true;
    },
  };
}
